import DataSource from "../DataSource";

export default class MeradloService {
  constructor(server, FileService){
    this.server = server;
    this.FileService = FileService;
  }
 
  get(id){
    return this.server("meradlo.get", {id: id});
  }

  save(id, item){
    return this.server("meradlo.update", {id: id, data: item});
  }

  stavSource(meradloId){
    var s = new DataSource(this.server, "stavmeradla.list.source");
    s.filter = {meradlo: meradloId};
    return s;
  }

  listSource(){
    return new DataSource(this.server, "meradlo.list.source")
  }

  listMy(){
    return this.server("meradlo.list.my");
  }

  exportSamoodpocet(){
    return this.server("meradlo.samoodpocet.export");
  }

  importSource(){
    return new DataSource(this.server, "meradlo.import.source", {limit: 100});
  }

  importConfirm(ids){
    return this.server("meradlo.import.confirm", {ids: ids});
  }

  importCancel(ids){
    return this.server("meradlo.import.cancel", {ids: ids});
  }

  importXls(file){
    return this.FileService.read(file).then(file => this.server("meradlo.import.xls", {file: file}));
  }

}


// WEBPACK FOOTER //
// ./src/Meradlo/MeradloService.js